import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

const contents = [
  'Bệnh nhân cần được đặt ống thông khí nội quản để đảm bảo và duy trì đường thở trong các tình huống khẩn cấp như hồi sức tim phổi, suy hô hấp, tắc nghẽn đường thở trên, v.v., nhằm \nngăn ngừa việc hít vào dạ dày, hỗ trợ loại bỏ dịch tiết đường hô hấp và cung cấp thông khí cơ học nếu cần thiết, như được chỉ định trong các tình trạng liên quan.',
  'Cần thiết sau khi tiêm thuốc an thần hoặc thuốc làm co cơ, bệnh nhân được đặt ở tư thế nằm ngửa trên giường. Sau đó, ống nội soi được đưa vào miệng, nâng cánh họng để chèn ống \nnhựa qua dây thanh quản vào đường thở của bệnh nhân.',
];

const ResultPurpose = () => {
  return (
    <>
      <SectionTitle title="1. Sự cần thiết của thủ tục" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
              marginBottom: '20px',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default ResultPurpose;
